import { render, staticRenderFns } from "./Assumptions.vue?vue&type=template&id=21297fbc&"
import script from "./Assumptions.vue?vue&type=script&lang=js&"
export * from "./Assumptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports